import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable()
export class ConfigService {

    _apiURI : string;

    constructor() {
        //this._apiURI = '/api';
        //this._apiURI = 'http://localhost:7701/api';
        this._apiURI = environment.apiURL;
     }

     getApiURI() {
         return this._apiURI;
     }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/config.service.ts